module.exports = __webpack_public_path__ + "static/media/client-13.c24bbe6e.jpg";